import {
  ApiInstanceFieldWithTypeAndName,
  PutValues,
  CreateValues,
  ApiInstanceField,
} from '../models/orchestrator/apiInstanceField';
import { SetValues } from '../models/orchestrator/instanceField';
import OrchestratorAPI from './common';

type FindForApiInstanceSearch =
  | {
      canonicalFieldId: string;
    }
  | {
      canonicalFieldTypeName: string;
      canonicalFieldValue?: string;
    }
  | {
      canonicalFieldTypeName: string;
      apiInstanceFieldValue?: string;
    };

export default class API extends OrchestratorAPI {
  protected readonly API_PATH = '/api-instance-fields';

  async findForApiInstance(
    apiInstanceId: string,
    searchQuery?: FindForApiInstanceSearch,
  ): Promise<ApiInstanceFieldWithTypeAndName[]> {
    const url = this.constructPath(
      `/api-instances/${apiInstanceId}`,
      searchQuery,
    );
    const { apiInstanceFields } = await this.common.getJSON(url);
    return apiInstanceFields.map(this.deserialize);
  }

  async setForApiInstance(
    apiInstanceId: string,
    canonicalFieldTypeId: string,
    values: SetValues[],
  ): Promise<ApiInstanceField[]> {
    const url = this.constructPath(
      `/api-instances/${apiInstanceId}/canonical-field-types/${canonicalFieldTypeId}`,
    );
    const { apiInstanceFields } = await this.common.postJSON(url, values);
    return apiInstanceFields.map(this.deserialize);
  }

  async updateForApiInstance(
    apiInstanceId: string,
    canonicalFieldTypeId: string,
    values: PutValues[],
  ): Promise<ApiInstanceFieldWithTypeAndName[]> {
    const url = this.constructPath(
      `/api-instances/${apiInstanceId}/canonical-field-types/${canonicalFieldTypeId}`,
    );
    const { apiInstanceFields } = await this.common.putJSON(url, values);
    return apiInstanceFields.map(this.deserialize);
  }

  async create(values: CreateValues): Promise<ApiInstanceFieldWithTypeAndName> {
    const url = this.constructPath(`/`);
    return this.common.postJSON(url, values);
  }

  async delete(apiInstanceFieldId: string): Promise<void> {
    const url = this.constructPath(`/${apiInstanceFieldId}`);
    return this.common.deleteJSON(url);
  }
}
